import { SliderItem } from "../../../../types";

export const generateSlideId = () => {
    return `slide-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
};

export const ensureIds = (items: SliderItem[]): SliderItem[] => {
    return (items || []).map((it, idx) => ({
        ...it,
        id: it.id || String(idx)
    }));
};

export const getSafeHash = (str: string) => {
    try {
        return btoa(encodeURIComponent(str)).substring(0, 16);
    } catch (e) {
        return Math.random().toString(36).substring(2, 11);
    }
};
